import * as React from "react";
import { QnACardProps } from "./QnACard";
import Card, { CardType } from "./Card";

const CSHPQnACard = (props: QnACardProps) => {
	const data: CardType = {
		title: "Expert Q&A",
		textPrefix: "Q: ",
		text: props.questionSnippet,
		imageURL: props.imageURL,
		thumbnailURL: props.thumbnailURL,
		positiveReviewsCount: props.positiveReviewCount,
		link: props.questionURL,
		linkText: "See answer",
		id: props.questionId,
		cardNumber: props.cardNumber,
		cardClickHandler: props.click,
	};
	return <Card data={data} />;
};

CSHPQnACard.displayName = "CSHPQnACard";
export default CSHPQnACard;
